import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { emailValidator } from 'src/app/_utlis/app-validators';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { DefulatRouting } from 'src/app/_utlis/enums/defualt-routing.enum';
import { environment } from 'src/environments/environment';

// Removed: getCurrentLngData, getPageData - migrated to ngx-translate
import { ActivatedRoute } from '@angular/router';
import { PreviousRouteService } from 'src/app/Shared/services/previous-route/previous-route.service';
import { Router } from '@angular/router';
import { Location, NgClass } from '@angular/common';
import { getQueryString } from 'src/app/_utlis/convert-url';

import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BreadCrumbsComponent } from 'src/app/Shared/components/bread-crumbs/bread-crumbs.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { LogoComponent } from 'src/app/Shared/components/logo/logo.component';
import { LanguageSwitcherComponent } from 'src/app/Shared/components/language-switcher/language-switcher.component';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';

@Component({
    selector: 'app-forget-password',
        standalone: true,
templateUrl: './buyer-forget-password.component.html',
    styleUrls: ['./buyer-forget-password.component.scss'],
    imports: [
    ReactiveFormsModule,
    BreadCrumbsComponent,
    NgClass,
    TranslatePipe
]
})
export class BuyerForgetPasswordComponent {
  formData!: FormGroup;
  // defualtPath=DefulatRouting.DEFUALT;
  defualtPath = environment.wordpressUrl;userType: string = 'buyer';
  breadcrumbItems: Breadcrumb[] = [];
  navTranslation: any;
  resetLinkSent: boolean = false;
  isLoading: boolean = false;
  userEmail: string = '';
  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private previousRouteService: PreviousRouteService,
    private _location: Location,
    private analyticsService: AnalyticsService
  ) {
    this.initForm();
  }initForm() {
    this.formData = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([Validators.required, emailValidator])
      ),
    });
  }
  onSubmit() {
    this.toastService.clear();

    if (this.formData.valid) {
      this.userEmail = this.formData.get('email')?.value;
      this.isLoading = true;
      this.authService
        .forgetPassword(this.formData.value.email, this.userType)
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.resetLinkSent = true;
            // Track password reset requested
            // this.analyticsService.trackPasswordReset('requested', 'buyer');
          },
          error: (error) => {
            this.isLoading = false;
            this.resetLinkSent = false;
            // BXS-3586: the error toast is shown globally by ResponseCheckInterceptor
            // (HTTP 422). Component-level toast removed to stop the duplicate message.
          },
        });
    }
  }

  back() {
    this._location.back();
  }
}
